var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 383.05 382.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #06513d;\n      }\n\n      .cls-2 {\n        fill: #387464;\n      }\n\n      .cls-3 {\n        fill: #fdfefe;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206.39,0h-29.94C83.79,7.64,7.67,81.5.51,175.47L.01,181.96v20.07s.6,6.88.6,6.88c5.39,61.32,40.38,116,92.75,147.33-.13-1.17.21-2.32,1.32-3.15l26.2-26.15,1.32-2.59c-17.91-9.35-33.9-22.26-46.8-38.35-3.28-4.09-4.04-9.84-2.81-14.97,6.53-27.03,22.09-51,44.18-67.76,7.52-5.7,16.18-3.26,23.26,1.66,30.11,20.92,70.89,20.87,101.5,1.04,3.48-2.26,6.03-4.64,9.95-5.48-.01-.64-.35-2.32.53-3.2l100.82-100.83c1.23-1.24,1.7-2.16,3.59-2.22C324.69,40.42,268.32,5.19,206.39,0ZM191.41,195.95c-37.99,0-68.78-30.8-68.78-68.79s30.79-68.78,68.78-68.78,68.79,30.79,68.79,68.78-30.8,68.79-68.79,68.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M383.05,176.65v29.94c-1.77,1.3-.99,3.1-1.21,5.37-4.05,41.1-21.82,79.5-49.77,109.72-3.72,4.02-7.2,7.14-11.01,10.79-9.71,9.3-20.18,16.84-31.75,23.8-26.5,15.93-55.91,24.81-86.78,26.68h-22.21c-31.04-1.88-60.63-10.95-86.96-26.71-.13-1.17.21-2.32,1.32-3.15l26.2-26.15,1.32-2.59c62.84,32.81,140.35,17.04,185.14-38.14,3.01-3.71,4.21-9.43,3.03-14.49-6.19-26.61-21.16-49.78-42.18-66.95-4.92-4.02-10.62-5.59-16.71-4.28-.01-.64-.35-2.32.53-3.2l100.82-100.83c1.23-1.24,1.7-2.16,3.59-2.22,13.78,23.38,22.82,49.49,25.44,77.08.2,2.16-.59,4.08,1.19,5.33Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M251.48,200.49c6.09-1.31,11.79.27,16.71,4.28,21.02,17.17,35.99,40.34,42.18,66.95,1.18,5.06-.02,10.78-3.03,14.48-44.79,55.18-122.3,70.96-185.14,38.15-17.91-9.36-33.9-22.26-46.8-38.35-3.28-4.1-4.05-9.84-2.81-14.97,6.52-27.03,22.08-51.01,44.18-67.76,7.52-5.7,16.18-3.26,23.26,1.66,30.11,20.93,70.89,20.88,101.49,1.04,3.49-2.26,6.03-4.64,9.95-5.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 191.41,
    cy: 127.16,
    r: 68.78
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarGreen);
export default __webpack_public_path__ + "static/media/avatar_green.45eaf876f3d754677308e79c37449f3f.svg";
export { ForwardRef as ReactComponent };